<template>
  <div>
    <div class="flex mb-4" style="align-items: center;">
      <h5>장비점검계획</h5>
      <vs-spacer></vs-spacer>
      <vs-button color="secondary" @click="showApproval">결재 프로세스</vs-button>
    </div>
    <div style="margin-left:-1.2rem; margin-right:-1.2rem; padding:1.2rem; background: #fff;">
      <vs-col class="mb-2 flex" vs-justify="flex-end">
        <vs-button class="w-1/2 mr-2" color="secondary" type="border" @click="handleClickClose">닫기</vs-button>
        <vs-button class="w-1/2 ml-2" color="secondary" v-if="board.savable" @click="handleClickUpdate">임시저장</vs-button>
        <vs-button v-if="board.resend" class="w-1/2 ml-2" color="secondary" @click="handleClickRegister">임시저장 후 재상신</vs-button>
      </vs-col>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>

      <vs-row class="mb-4 flex flex-wrap" >
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">사무소명</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" :value="projectInfo.field_name" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4">작성자</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.writer" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">근무기간</vs-col>
          <vs-col class="w-9/12">
            <vs-select autocomplete class="w-full" v-model="form.work_type">
              <vs-select-item text="근무구분1" value="workType1"/>
              <vs-select-item text="근무구분2" value="workType2"/>
              <vs-select-item text="근무구분3" value="workType3"/>
              <vs-select-item text="근무구분4" value="workType4"/>
              <vs-select-item text="근무구분5" value="workType5"/>
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4 ">소속</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.company" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">제목</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.title"/></vs-col>
        </vs-row>
      </vs-row>

      <vs-row class="mb-4">
        <vs-col class="flex mb-4">
          <h5><i class="dot"></i>점검계획</h5>
          <vs-spacer></vs-spacer>
          <a v-if="!board.readonly" @click="handleClickAddPlan" style="color:#6670CB;">+ 항목추가</a>
          <span v-if="!board.readonly" class="mx-4">|</span>
          <a v-if="!board.readonly" @click="handleClickRemovePlan" style="color:#6670CB;">- 항목삭제</a>
        </vs-col>
        <vs-col class="flex" style="align-items: center;">
          <vs-col class="w-3/12 title">점검계획일</vs-col>
          <date-selector class="w-9/12" v-model="form.check_date"/>
        </vs-col>
      </vs-row>

      <vs-row class="border mb-0" style="width: auto; margin-left:-1.2rem; margin-right:-1.2rem;" v-for="(issue, index) in plan_list" :key="index">
        <vs-col class="flex" style="padding:12px 1.25rem; background-color: #fafafa; border-top:1px solid #cdcdcd; border-bottom:1px solid #cdcdcd;" >
          <vs-checkbox v-model="issue.is_checked" :disabled="board.readonly">선택</vs-checkbox>
          <vs-spacer></vs-spacer>
          <div style="display: flex; align-items: center; justify-content: center; padding:8px; transition: all .3s ease;"
               :style="issue.is_hidden ? '-webkit-transform: rotate(180deg);' : ''"
               @click="()=>{handleClickHidden(issue)}">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.41 7.41016L6 2.83016L10.59 7.41016L12 6.00016L6 0.000156403L0 6.00016L1.41 7.41016Z" fill="black"/>
            </svg>
          </div>
        </vs-col>
        <vs-col style="padding: 12px 1.25rem 0px; transition: all .3s ease;" :style="issue.is_hidden ? 'height:0; opacity:0; overflow: hidden;' : ''">
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">구분</span>
            <span class="w-8/12">
              <vs-select autocomplete class="w-full mb-0" row="5" v-model="issue.type" >
                <vs-select-item text="굴삭기A" value="type_a"/>
                <vs-select-item text="굴삭기B" value="type_b"/>
                <vs-select-item text="굴삭기C" value="type_c"/>
              </vs-select>
            </span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">장비명</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="issue.name" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">관리번호</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="issue.control_num" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">모델명</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="issue.model_name" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">제조사</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="issue.manufacturer" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">안전인증일/<br>인증기관</span>
            <span class="w-8/12" style=" display: grid;">
              <date-selector class="w-full mt-0 mb-2" v-model="issue.inspection_date"/>
              <vs-input class="w-full mb-0" row="5" v-model="issue.inspection_com" :readonly="board.readonly"></vs-input>
            </span>
          </vs-col>
          <vs-col class="flex mb-4 " style="align-items: center; ">
            <span class="w-4/12">안전-정기 검사일/<br>검사기관</span>
            <span class="w-8/12" style="display: grid;">
              <date-selector class="w-full mt-0 mb-2" v-model="issue.check_date"/>
              <vs-input class="w-full mb-0" row="5" v-model="issue.check_com" :readonly="board.readonly"></vs-input>
            </span>
          </vs-col>

        </vs-col>
      </vs-row>

      <vs-row :class="isShowApproval?'':'hidden'" style="position:fixed; top:0; left:0; bottom:0; right:0; z-index:45000; background: rgba(0,0,0,0.7); ">
        <div style="position: relative; width: 100%; height:100%; display: grid; grid-template-rows: 110px; minmax(0%,100%); overflow-y: auto;">
          <vs-spacer @click="hideApproval"></vs-spacer>
          <approval-process-module
            :board="board"
            :commentabled="!(board.isCompleteApproval || board.savable)"

            @handleClickUpload="handleClickUpload"
            @handleClickOk="handleClickOk"
            @handleClickNo="handleClickNo"
            @handleSendApprovalProcess="handleSendApprovalProcess"
          ></approval-process-module>
          <a style="width:33px; height:33px; position:absolute; top:77px; right:10px;"  @click="hideApproval">
            <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
          </a>
        </div>

      </vs-row>


    </div>

    <!-- TODO : 얼럿데이터 -->
    <popup-alert v-model="alert.show"
                 :is-confirm="alert.isConfirm"
                 :html="alert.html"
                 :message="alert.message"
                 :buttons="alert.buttons"

                 @ok="alertOk"
                 @no="alertNo"
                 @upload="alertUpload"
    ></popup-alert>
  </div>
</template>

<script>
import ApprovalProcessModule from '@/views/modules/ApprovalProcessModule'
import PopupAlert from '@/views/components/popup/PopupAlert'
import DateSelector from '@/views/components/DateSelector'
import PopupEquipmentResult from '@/views/project/popup/PopupEquipmentResult'
import VueCookie from 'vue-cookie'
import SafetyEquipmentPlanTableList from '@/views/project/safety/equipment/components/SafetyEquipmentPlanTableList'

export default {
  name: 'MobileSafetyEquipmentCheckUpdate',
  components: {
    SafetyEquipmentPlanTableList,
    PopupEquipmentResult,
    DateSelector,
    PopupAlert,
    ApprovalProcessModule
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    }
  },
  data () {
    return {
      boardSlug: 'construction_equipment',
      boardId: '24',
      registerable:false,

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: 'construction_equipment',
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        resend: false, // 재등록 가능한가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        collection: true, // 문서 회수가 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },

      // TODO : 얼럿데이터
      alert: {
        show: false,
        message: '결재하시겠습니까?',
        buttons: [
          {
            label: '승인',
            action: 'ok'
          },
          {
            label: '취소',
            action: 'cancel'
          }
        ]
      },
      planAllCheck: false,
      approvalLine: [], // 결재선 등록


      table: {
        list: [],
        perPage: 7,
        keyword: ''
      },
      popupActive: false,

      form: {
        project_title: '',
        title: '',
        writer: '',
        work_type:'',
        company: '',
        check_date:'',
        plan_list: [],
        preview: {
          project_title: '',
          title: '',
          work_type:'',
          check_date: '',
          move_date: '',
          result_date: '',
          plan_list: []
        }
      },
      plan_list: [],
      selectPlanDetail:{},
      selectPlanIndex:'',
      afterId:'',
      oldForm:{},
      oldPlanList:[],
      fileList: [],
      isShowApproval: false
    }
  },

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {

      if (JSON.stringify(this.oldForm) === JSON.stringify(this.form)) {
        next(true); return
      } else if (confirm('저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?')) {
        next(true); return
      }

      next(false)
    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },


  async created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}`

    await this.loadPost()
  },

  methods: {
    back () {
      this.$router.back()
    },
    async loadPost () {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = this.$store.state.approval.postInfo
      this.form = JSON.parse(post.post_content)
      const afterList = this.$store.state.approval.postAfters

      //
      if (afterList.length > 0) {
        this.afterId = afterList[0].id
        const dataList = JSON.parse(afterList[0].after_content)
        for (let i = 0; i < dataList.data.length; i++) {
          const after = dataList.data[i]
          this.form.plan_list[i].after = after
        }
      } else {
        for (const plan of this.form.plan_list) {
          plan.after = {
            workPlan:[
              {
                check_list: '작업장의 지형,지반 사전조사 여부',
                check_result: '',
                action: ''
              },
              {
                check_list: '작업계획서 작성 적정여부',
                check_result: '',
                action: ''
              }
            ],
            driver:[
              {
                check_list: '운전원 면허 자격 여부(3톤 미만 소형건설기계 조종교육 이수...)',
                check_result: '',
                action: ''
              },
            ],
            safetyDevice:[
              {
                check_list: '버킷 유압커플러',
                check_result: '',
                action: ''
              },
              {
                check_list: '후진경보장치',
                check_result: '',
                action: ''
              }
            ],

            actionDate: '',
            actionResult: '',
            before:{},
            after:{}
          }
        }
      }


      const files = post.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      this.plan_list = this.form.plan_list
      this.registerable = this.$store.state.approval.postInfo.author.id === this.$store.state.auth.userInfo.id

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))

      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
      this.approvalLine = doc.line.slice() // api 전송용

      this.oldForm = JSON.parse(JSON.stringify(this.form))
      this.oldPlanList = JSON.parse(JSON.stringify(this.plan_list))

    },

    async register (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      // 등록정보
      const projectId = this.$route.params.proj_id
      const boardId = this.boardId
      const boardSlug = this.boardSlug
      const title = this.form.title
      const postId = this.$route.params.postId
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))

      for (const plan of this.plan_list) {
        plan.boardId = boardId
        plan.boardSlug = boardSlug
        plan.postId = postId
      }

      this.form.plan_list = this.plan_list

      // 리스트 노출 정보
      this.form.project_title = this.projectInfo.field_name
      this.form.preview.project_title = this.form.project_title
      this.form.preview.title = this.form.title
      this.form.preview.work_type = this.form.work_type
      this.form.preview.check_date = this.form.check_date
      this.form.preview.move_date = this.form.move_date
      this.form.preview.result_date = this.form.result_date
      this.form.preview.plan_list = this.form.plan_list
      const content = JSON.stringify(this.form)

      try {
        if (this.formCheck()) {

          if (isUploaded) {
            // 바로 상신하기
            const unTemp = 'y'
            await this.$store.dispatch('approval/UPDATE_POST', {
              projectId,
              boardSlug,
              postId,
              title,
              content,
              approvalLine,
              unTemp
            })
            alert('상신되었습니다.')
            this.oldForm = JSON.parse(JSON.stringify(this.form))
            this.back()
          } else {
            // 임시 저장하기
            const unTemp = 'n'
            await this.$store.dispatch('approval/UPDATE_POST', {
              projectId,
              boardSlug,
              postId,
              title,
              content,
              approvalLine,
              unTemp
            })
            alert('임시저장되었습니다.')
            this.oldForm = JSON.parse(JSON.stringify(this.form))
            this.back()
          }
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
        }
      }

    },
    async reRegister (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      // 등록정보
      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug
      const title = this.form.title
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const security = 'normal' // 문서보안 등급 ['일반', 대외비 1급, 대외비 2급, 인비, 극비] [normal,confidential1,confidential2,personally,confidential0]
      const priority = 'medium' // 문서 중요도 [매우낮음, 낮음, 보통, 높음, 매우 높음] [lowest,low,medium,high,highest]

      this.form.plan_list = this.plan_list

      // 리스트 노출 정보
      this.form.project_title = this.projectInfo.field_name
      this.form.preview.project_title = this.form.project_title
      this.form.preview.title = this.form.title
      this.form.preview.work_type = this.form.work_type
      this.form.preview.check_date = this.form.check_date
      this.form.preview.move_date = this.form.move_date
      this.form.preview.result_date = this.form.result_date
      this.form.preview.plan_list = this.form.plan_list
      const content = JSON.stringify(this.form)

      try {
        if (this.formCheck()) {

          if (isUploaded) {
            // 바로 상신하기
            await this.$store.dispatch('approval/CREATE_POST', {
              projectId,
              boardSlug,
              title,
              content,
              approvalLine,
              security,
              priority
            })
            alert('상신되었습니다.')
            this.oldForm = JSON.parse(JSON.stringify(this.form))
            this.back()
          } else {
            // 임시 저장하기
            const isTemp = 1
            await this.$store.dispatch('approval/CREATE_POST', {
              projectId,
              boardSlug,
              title,
              content,
              approvalLine,
              security,
              priority,
              isTemp
            })
            alert('임시저장되었습니다.')
            this.oldForm = JSON.parse(JSON.stringify(this.form))
            this.back()
          }
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
        }
      }

    },

    handleClickHidden (issue) {
      issue.is_hidden = !issue.is_hidden;
    },

    formCheck () {
      if (this.form.work_type.trim().length <= 0) {
        alert('근무구분을 선택해주세요')
        return false
      } else if (this.form.title.trim().length <= 0) {
        alert('제목을 입력해주세요')
        return false
      }
      return true
    },

    // TODO : 얼럿데이터
    alertUpload () {
      this.register(true)
    },

    // TODO : 결재프로세스
    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    lineToSendLine (data) {
      const approvalList = []

      for (const member of data) {
        if (member.type_code !== 'register') {
          approvalList.push({
            id: member.user_id,
            name: member.user_name,
            elementType: member.type_code
          })
        }
      }

      return approvalList
    },

    handleClickClose () {
      this.back()
    },

    addPlan (name, size, quantity, unit_price, price, etc) {
      this.plan_list.push({
        is_checked: this.planAllCheck,
        name, // 품목명
        size, // 규격
        quantity, // 수량
        unit_price, // 단가
        price, // 금액
        etc // 비고
      })
    },
    addPlanEmpty () {
      this.addPlan('', '', '', '', '', '')
    },
    changePlanAllCheck () {
      for (const data of this.plan_list) {
        data.is_checked = this.orderAllCheck
      }
    },
    handleClickUpdate () {
      if (confirm('저장하시겠습니까?')) {
        this.register(false)
      }
    },

    handleClickRegister () {
      if (confirm('임시저장 하시겠습니까?')) {
        this.reRegister(false)
      }
    },

    handleClickAddPlan () {
      this.addPlanEmpty()
    },

    handlePlanChangeChecked () {
      let count = 0
      for (const data of this.plan_list) {
        if (data.is_checked === true) {
          count++
        }
      }
      this.planAllCheck = (Number(count) === Number(this.plan_list.length))
    },
    handlePlanSelected (item) {
      if (this.board.statusCode === 'approved') {
        const boardSlug = this.boardSlug
        const boardId = this.boardId
        const postId = this.$route.params.postId

        item.boardSlug = boardSlug
        item.boardId = boardId
        item.postId = postId
        this.selectPlanDetail = item

        this.popupActive = true

      }
    },
    handleClickRemovePlan () {
      for (let i = 0; i < this.plan_list.length; i++) {
        if (this.plan_list[i].is_checked) {
          this.plan_list.remove(this.plan_list[i])
          i = -1
        }
      }

      this.planAllCheck = false
    },

    handleBackMenu () {
      this.$emit('handleBackMenu', 'plan')
    },

    popupActiveSync () {
      this.popupActive = false
    },

    handleClickNo () {
      this.alert.html = '<p>반려하시겠습니까?</p><p>아래에 사유를 작성해주세요.</p>'
      this.alert.message = ''
      this.alert.isConfirm = true
      this.alert.buttons = [
        {
          label: '반려',
          action: 'no'
        },
        {
          label: '취소',
          action: 'cancel',
          type: 'border'
        }
      ]
      this.alert.show = true
    },

    async handleClickOk () {
      this.alert.html = ''
      this.alert.message = '승인하시겠습니까?'
      this.alert.isConfirm = false
      this.alert.buttons = [
        {
          label: '승인',
          action: 'ok'
        },
        {
          label: '취소',
          action: 'cancel',
          type: 'border'
        }
      ]
      this.alert.show = true

    },
    handleClickUpload () {
      this.alert.buttons = [
        {
          label: '상신',
          action: 'upload'
        },
        {
          label: '취소',
          action: 'cancel',
          type: 'border'
        }
      ]
      this.alert.show = true
    },

    // TODO : 얼럿데이터
    async alertOk () {

      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {
        postId
      })

      this.oldForm = JSON.parse(JSON.stringify(this.form))
      document.location.reload()
    },

    async alertNo (text) {
      const postId = this.$route.params.postId
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', {
        postId,
        comment
      })
      document.location.reload()
    },

    handleSendApprovalProcess (process) {
      this.approvalLine = process
    },

    showApproval () {
      this.isShowApproval = true
    },

    hideApproval () {
      this.isShowApproval = false
    }
  }
}
</script>

<style scoped>
</style>
